export default "/assets/5630e5cb2b4475f8.svg"